import { type OFFER_STATUS, OFFER_STATUS_TEXT } from './constants';
import type { PublicCellData } from '../../../graphql';
import type { HeadCell } from '../../../../../components';
import { MONITOR_LIST_TEXT } from '../../../lang';

export const publicHeadCells: Array<HeadCell<PublicCellData>> = [
  {
    id: 'applicationNo',
    label: MONITOR_LIST_TEXT.APPLICATION_NO,
    isSortable: false,
    render: (row: PublicCellData) => row.applicationNo,
  },
  {
    id: 'applicantName',
    label: MONITOR_LIST_TEXT.APPLICANT_NAME,
    isSortable: false,
    render: (row: PublicCellData) => row.applicantName,
  },
  {
    id: 'department',
    label: MONITOR_LIST_TEXT.DEPARTMENT,
    isSortable: false,
    render: (row: PublicCellData) => row.department,
  },
  {
    id: 'proposedChiefSupervisor',
    label: MONITOR_LIST_TEXT.CHIEF_SUPERVISOR,
    isSortable: false,
    render: (row: PublicCellData) => row.proposedChiefSupervisor,
  },
  {
    id: 'progLevel',
    label: MONITOR_LIST_TEXT.PROG_LEVEL,
    isSortable: false,
    render: (row: PublicCellData) => row.progLevel,
  },
  {
    id: 'studyMode',
    label: MONITOR_LIST_TEXT.STUDY_MODE,
    isSortable: false,
    render: (row: PublicCellData) => row.studyMode,
  },
  {
    id: 'entryYear',
    label: MONITOR_LIST_TEXT.ENTRY_YEAR,
    isSortable: false,
    render: (row: PublicCellData) => row.entryYear,
  },
  {
    id: 'progType',
    label: MONITOR_LIST_TEXT.PROG_TYPE,
    isSortable: false,
    render: (row: PublicCellData) => row.progType,
  },
  {
    id: 'status',
    label: MONITOR_LIST_TEXT.STATUS,
    isSortable: false,
    render: (row: PublicCellData) =>
      OFFER_STATUS_TEXT[row.status as keyof typeof OFFER_STATUS],
  },
];
